// src/config/subPlans.js

const SUBSCRIPTION_PLANS = {
    standard: {
      name: 'Standard',
      messageLimit: 500,
      features: [
        '500 AI messages per month',
        // 'Basic data analytics'
      ]
    },
    pro: {
      name: 'Pro',
      messageLimit: 5000,
      features: [
        '5000 AI conversations',
        'Advanced data analytics',
        'Priority support'
      ]
    },
    advanced: {
      name: 'Advanced',
      messageLimit: 50000,
      features: [
        '50000 AI conversations',
        'Advanced data analytics',
        'Priority support',
        'Custom AI training'
      ]
    },
    sales: {
        name: 'Sales',
        messageLimit: 500000,
        features: [
          'Customer service',
        ]
      },
    admin: {
        name: 'Admin',
        messageLimit: 500000,
        features: [
          'System administration',
          'User management',
          'Full access'
        ]
      },
      owner: {
        name: 'kc',
        messageLimit: 5000000,
        features: [
          ''
        ]
      }
  };
  
  export const getPlanDetails = (planType) => {
    const plan = planType ? planType.toLowerCase() : 'standard';
    return SUBSCRIPTION_PLANS[plan] || SUBSCRIPTION_PLANS.standard;
  };
  
  export default SUBSCRIPTION_PLANS;